import { SET_NOT,SET_FL,SET_GALY,SET_TAB } from "./mutation-type";

export default {
  [SET_NOT](state, noticeFlag) {
    state.noticeFlag = noticeFlag;
  },
  [SET_FL](state, fldata) {
    state.fldata = fldata;
  },
  [SET_GALY](state, gallyIndex) {
    state.gallyIndex = gallyIndex;
  },
  [SET_TAB](state, tabIndex) {
    state.tabIndex = tabIndex;
  },
};